import { HStack, Text } from '@chakra-ui/react';

import Icon, { IconType } from 'components/Icon';
import { PaymentMethodType } from 'types/edgeFunctions';

const PAYMENT_METHOD_ICONS: Partial<Record<PaymentMethodType, IconType>> = {
  paypal: 'PayPalGray',
  link: 'Link',
};

interface IPaymentMethodShortInfo {
  type: PaymentMethodType;
}

export const PaymentMethodShortInfo = ({ type }: IPaymentMethodShortInfo) => {
  const iconType = PAYMENT_METHOD_ICONS[type];

  return (
    <>
      <HStack
        borderRadius={8}
        bg="whiteAlpha.200"
        px={4}
        minH={16}
        shadow="0px 4px 24px 0px rgba(0, 0, 0, 0.24)"
      >
        {iconType ? <Icon type={iconType} size={64} /> : <Text>{type}</Text>}
      </HStack>
    </>
  );
};
